
import { Bot, TrendingUp } from "lucide-react";

interface LakshBotLogoProps {
  size?: number;
  withText?: boolean;
  className?: string;
}

const LakshBotLogo = ({ size = 24, withText = true, className = "" }: LakshBotLogoProps) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative">
        <Bot size={size} className="text-primary" />
        <TrendingUp 
          size={size * 0.6} 
          className="text-green-500 absolute -right-1 -bottom-1"
        />
      </div>
      
      {withText && (
        <span className="ml-2 text-xl font-semibold">
          Laksh<span className="text-primary">Bot</span>
        </span>
      )}
    </div>
  );
};

export default LakshBotLogo;
